export default __webpack_public_path__ + "static/media/Tasks.3e0f650a.svg";